import './modal-active-quotas-massive.scss';
import { useState, useRef, useEffect } from 'react';
import { ADD_CLOSE_QUOTAS_MASSIVE, CLASSES_BRANCH } from '../../graphql/branch';
import { useMutation } from '@apollo/client';
import Modal from '../modal-alert/modal-alert';
import Message from '../message/message';
import { MESSAGE_ADD_QUOTAS } from '../../../class-branch/constants/messages';
import { Button } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

interface Props {
    classIds: any[];
    quotas: any[];
    day: string;
    isLoading?: boolean;
    onEventActive: (result: any) => void;
}

export const ModalActiveQuotasMassive = ({ classIds, quotas, day, isLoading, onEventActive }: Props) => {
    const [modalVisible, setModalVisible] = useState(false);
    let message = MESSAGE_ADD_QUOTAS;
    message.open = useRef<any>(null);
    const [ActiveQuotas, { data, loading, error, reset }] = useMutation(ADD_CLOSE_QUOTAS_MASSIVE, {
        refetchQueries: [CLASSES_BRANCH]
    });
    
    if (data) {
        message.textMessage = data.AddAndCloseQuotasMassive.message;
        message.style = data.AddAndCloseQuotasMassive.success ? 'success':'danger';
        setModalVisible(!modalVisible);
        setTimeout(() => {
            message.open.current.show();
            handleAddCuotas();
        }, 500);
        reset();
    }

    const handleAddCuotas = () => {
        onEventActive('Reload classes, from ACTIVATE');
    };

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    
    if (error) console.log(`Submission error! ${error.message}`);

    return (
        <div className="modal-active-quotas-massive">
            {!isLoading && (
                <Button onClick={() => setModalVisible(true)} className="modal-button">
                    {windowWidth >= 531 ? <span>Abrir todos los cupos </span> : <span>Abrir cupos</span>}
                </Button>
            )}

            {isLoading && <CircularProgress size={25} />}
        
            {modalVisible && (
                <Modal
                    estatus={modalVisible}
                    changeStatus={modalVisible}
                    showHeader={false}
                    buttonCancel={false}
                >
                <div className='content'>
                    <h1>Abrir cupos</h1>
                    <p>
                        ¿Está seguro de abrir todos los cupos del día?
                        <br />
                        <br />
                        <b>Recuerda</b> que si estas usando filtros como rango horario o terminos de búsqueda, se
                        aplicarán al día seleccionado.
                    </p>
                    <div className="buttons">
                    <Button onClick={() => setModalVisible(false)} className="cancel-button">
                        Cancelar
                    </Button>
        
                    <Button disabled={loading} onClick={() => {
                        ActiveQuotas({
                        variables: {
                            userId: null,
                            calendarIds: classIds,
                            close: false,
                            quotas: quotas,
                        },
                        });
                    }}>
                        {!loading ? (
                        <>Abrir Cupos</>
                        ) : (
                        <CircularProgress size={25} />
                        )}
                    </Button>
                    </div>
                </div>
                </Modal>
            )}
        
            <Message data={message} ref={message.open} />
        </div>
    );
}